import styled from 'styled-components';
import { Button } from 'newcomponents/UI/Button';

export const StakeWrapper = styled.div<{ $paddingLeft?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${props => (props.$paddingLeft ? `padding: 0` : `padding: 0 12px`)}
`;

export const Value = styled.div<{ active: boolean }>`
  font-size: 14px;
  min-width: 2px;
  min-height: 20px;
  line-height: 20px;
  position: relative;
  display: inline-block;
  color: var(--v3-text-color);
  ${props =>
    props.active &&
    ` &:after {
        top: 10%;
        right: 0;
        content: '';
        height: 80%;
        position: absolute;
        margin-left: 3px;
        border-right: 1.5px solid #108ee9;
        -webkit-animation: keyboard-cursor infinite 1s step-start;
        animation: keyboard-cursor infinite 1s step-start;
        right: 0;
      }

  `}
`;

export const Placeholder = styled.div<{ $paddingLeft?: boolean }>`
  color: var(--v3-text-color-secondary);
  white-space: nowrap;
  line-height: 20px;
  font-size: 14px;
  left: 2px;
  top: 0;
  ${props => (!props.$paddingLeft ? `padding-left: 0px` : `padding-left: 0`)}
`;

export const Max: any = styled(Button)<{ $oddOffer?: boolean }>`
  width: auto !important;
  min-width: 52px;
  height: 32px;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-direction: row !important;
  padding: 6px 12px !important;
  border: none !important;
  border-radius: 4px !important;
  color: var(--v3-text-color) !important;
  background-color: var(--v3-black-6) !important;
  margin: 0 12px;
  &:hover {
    &:not([disabled]) {
      color: var(--v3-primary-6) !important;
      background-color: var(--v3-black-6) !important;
    }
  }

  &[disabled] {
    color: var(--v3-black-45) !important;
  }

  & span,
  div {
    font-size: ${props => (props.$oddOffer ? '12' : '14')}px;
    line-height: ${props => (props.$oddOffer ? '16' : '20')}px;
  }
`;
